import React, { useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Button from '@material-ui/core/Button'
import AltaFirmwareModal from 'components/AltaFirmwareModal/AltaFirmwareModal'
import Error from 'components/Error/Error'
import Loader from 'components/Loader/Loader'
import NoData from 'components/NoData/NoData'
import PageTitle from 'components/PageTitle/PageTitle'
import Table from 'components/Table/Table'
import useCallService from 'services/useCallService'
import { GET_ALTA_FIRMWARE_URL } from 'Constants'
import useStyles from './styles'

const AltaFirmwarePanel = () => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  const { callGatewayService } = useCallService()
  const [altaFirmwaresList, setAltaFirmwareList] = useState([])
  const [parameters, setParameters] = useState({ sortBy: 'firmwareVersion', sorting: 'ASC' })
  const [openModal, setOpenModal] = React.useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    loadAltaFirmwareTable()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parameters])

  const loadAltaFirmwareTable = () => {
    async function fetchAltaControllers() {
      setIsLoading(true)
      setIsError(false)
      return callGatewayService(
        'GET',
        `${GET_ALTA_FIRMWARE_URL}?brand=${process.env.REACT_APP_PARTNER_NAME}&sortBy=${parameters.sortBy}&sorting=${parameters.sorting}`,
        {},
        true
      )
    }

    fetchAltaControllers()
      .then((response) => {
        setAltaFirmwareList(response.data)
      })
      .catch(() => setIsError(true))
      .finally(() => setIsLoading(false))
  }

  const handleSort = (order, orderBy) => {
    setParameters({
      sortBy: orderBy,
      sorting: order.toUpperCase()
    })
  }

  const handleOpenModal = () => {
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const columns = [
    {
      id: 'firmwareVersion',
      sorting: true,
      label: formatMessage({ id: 'AltaFirmware.column.firmwareVersion' }),
      width: classes.smallWidth
    },
    {
      id: 'createdDate',
      sorting: true,
      label: formatMessage({ id: 'AltaFirmware.column.releaseDate' }),
      type: 'date',
      width: classes.smallWidth
    },
    {
      id: 'releaseNotes',
      sorting: true,
      label: formatMessage({ id: 'AltaFirmware.column.releaseNotes' }),
      className: classes.wrapText,
      width: classes.mediumWidth
    },
    {
      id: 'createdBy',
      sorting: true,
      label: formatMessage({ id: 'AltaFirmware.column.uploadedBy' }),
      width: classes.smallWidth
    }
  ]

  return (
    <div className={classes.container}>
      <div className={classes.containerHeader}>
        <PageTitle titleId={'AltaFirmware.panel.title'} />
        <Button type={'button'} className={classes.button} onClick={handleOpenModal}>
          <FormattedMessage id={'AltaFirmware.panel.uploadNewFirmware'} />
        </Button>
      </div>
      <div className={classes.dataContainer}>
        {isError && <Error />}
        {isLoading && <Loader />}
        {!isError && !isLoading && altaFirmwaresList.length === 0 && <NoData />}
        {!isError && !isLoading && altaFirmwaresList.length > 0 && (
          <Table
            columns={columns}
            data={altaFirmwaresList}
            defaultOrderKey={parameters.sortBy}
            defaultOrder={parameters.sorting.toLowerCase()}
            onSortChange={handleSort}
            className={{ table: classes.table }}
          />
        )}
      </div>
      <AltaFirmwareModal
        open={openModal}
        handleClose={handleCloseModal}
        onSuccess={loadAltaFirmwareTable}
        title={formatMessage({ id: 'AltaFirmware.modal.title' })}
      />
    </div>
  )
}

export default AltaFirmwarePanel
